export const ACTIVE_STATUS_CODE = 1;
export const NO_SHOW_STATUS_CODE = 2;
export const COMPLETE_STATUS_CODE = 3;
export const CANCELLED_LT_24H_STATUS_CODE = 5;